// ABOUTME: The small still of the post an approval is about (its signed media from the card's
// subject). Nothing renders when the card names no post with media.
import type { AgentApprovalResponse } from '@/types'

export function ApprovalStill({
  approval,
  className = 'size-11',
}: {
  approval: AgentApprovalResponse
  className?: string
}) {
  const media = approval.subject?.media
  if (!media) return null
  const style = `${className} shrink-0 rounded-md bg-muted object-cover`
  if (media.kind === 'video' && !media.poster_url) {
    return (
      <video
        src={media.url}
        muted
        playsInline
        preload="metadata"
        className={style}
        data-testid="approval-thumbnail"
      />
    )
  }
  return (
    <img
      src={media.poster_url ?? media.url}
      alt=""
      loading="lazy"
      className={style}
      data-testid="approval-thumbnail"
    />
  )
}
